/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class PaymentDto {
    id: string;
    paymentLinkId: string;
    priceId: string;
    productId: string;
    url: string;
    subscriptionId: string | null;
    customerId: string | null;
    licensedUntil: Date | null;
    perpetualLicenseActiveSince: Date | null;
    createdOn: Date;
    modifiedOn: Date | null;
    chargeAutomatically: boolean;
    licenseActive: boolean;
}
